import Styles from './Change.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { EffectsMenu } from 'common/Prose/nodeViews/Image/components/FormatBar/EffectsMenu/EffectsMenu'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { useDocStore } from 'stores/DocStore'
import { ImageStoreContext } from 'stores/ImageStore'
import { LightMenu } from 'common/Prose/nodeViews/Image/components/FormatBar/LightMenu/LightMenu'
import { ColorMenu } from 'common/Prose/nodeViews/Image/components/FormatBar/ColorMenu/ColorMenu'
import { ContentMenu } from 'common/Prose/nodeViews/Image/components/FormatBar/ContentMenu/ContentMenu'

interface Props {
  attrs: ImageNodeAttrs
  onChange: () => void
}

const Change = ({ attrs, onChange }: Props) => (
  <div className={Styles.list}>
    <Text variant="secondary" color="var(--dark-80)">
      Change:
    </Text>
    <ColorMenu attrs={attrs} onAdjust={onChange} />
    <EffectsMenu attrs={attrs} onFilter={onChange} />
    <LightMenu attrs={attrs} onAdjust={onChange} />
    <ContentMenu attrs={attrs} onEdit={onChange} />
  </div>
)

const ChangeContainer = (props: Props) => {
  const { imageStores } = useDocStore()
  const imageStore = imageStores.get(props.attrs.src)

  if (!imageStore) return null

  return (
    <ImageStoreContext.Provider value={imageStore}>
      <Change {...props} />
    </ImageStoreContext.Provider>
  )
}

export { ChangeContainer as Change }
